import { CART_TYPE_TO_STATE_MAPPING } from "@checkout-core/constants/DineoutCart";
import { DineoutCartType } from "@checkout-core/contexts/DineoutCartContext";
import { isNull, isUndefined } from "@swiggy-private/js-utils";
import { safeJsonParse } from "@swiggy-private/core-ui";
import { SwgyHeaderType } from "@checkout-core/utils/Headers";

export const getDineoutFlowType = (cartType: DineoutCartType | null): string => {
    /* Flow type is required for the dineout cart bridge functions, so that app can identify which cart flow is being used e.g. table reservation, event booking or bill payment */
    /* If we don't pass the flow type, the bridge functions will not be able to identify which cart flow to update/delete 
    /* and this might create issues when the user is using multiple carts in the same app session */
    return !isNull(cartType) && !isUndefined(cartType) ? CART_TYPE_TO_STATE_MAPPING[cartType] : "";
};

// Helper function to decode HTML entities (e.g., &quot; -> ")
// Use window.decodeHtmlEntities from script.html
const decodeHtmlEntities = (text: string | undefined): string | undefined => {
    if (typeof window !== "undefined" && typeof window.decodeHtmlEntities === "function") {
        return window.decodeHtmlEntities(text);
    }
    return text;
};

// Parse heroinlinexpconfig header to extract dineout and scenes values
export const parseHeroInlineXpConfig = (
    headers: SwgyHeaderType,
): {
    isDineoutHeroApiInlineHtmlXp: string;
    isScenesHeroApiInlineHtmlXp: string;
    isStealdealHeroApiInlineHtmlXp: string;
} => {
    let isDineoutHeroApiInlineHtmlXp = "--";
    let isScenesHeroApiInlineHtmlXp = "--";
    let isStealdealHeroApiInlineHtmlXp = "--";
    const heroInlineXpConfig = headers?.heroinlinexpconfig;
    if (heroInlineXpConfig) {
        // Decode HTML entities before parsing JSON
        const decodedConfig =
            typeof heroInlineXpConfig === "string" ? decodeHtmlEntities(heroInlineXpConfig) : heroInlineXpConfig;
        const xpConfig =
            typeof decodedConfig === "string"
                ? safeJsonParse(decodedConfig, { dineout: "false", scenes: "false", stealDeal: "false" })
                : decodedConfig;
        isDineoutHeroApiInlineHtmlXp = xpConfig?.dineout || "--";
        isScenesHeroApiInlineHtmlXp = xpConfig?.scenes || "--";
        isStealdealHeroApiInlineHtmlXp = xpConfig?.stealDeal || "--";
    }
    return { isDineoutHeroApiInlineHtmlXp, isScenesHeroApiInlineHtmlXp, isStealdealHeroApiInlineHtmlXp };
};
